import { FinancialsColumnDefinition, FinancialsRowDataType } from '../../components/financials-table/types'
import { View } from '../../components/line-stacked-bar-chart'

export enum Category {
  products_and_services = 'products_and_services',
  regions = 'regions',
  segment = 'segment',
  subsegment = 'subsegment',
  additional = 'additional',
}

export type CategoryData = {
  revenues: Record<string, Array<{ fiscal_year: string; value: number }>>
  unit: string
}

export type RevenueData = Record<Partial<Category>, CategoryData>

export type RevenueColumnsType<T extends FinancialsRowDataType = FinancialsRowDataType> = {
  columns: FinancialsColumnDefinition<T>[]
  subColumns: Record<RevenueDataEnum, FinancialsColumnDefinition<T>[]>
}

// I kept the values with bool prefix because users may already have cookis with this keys
export enum RevenueDataEnum {
  yoyChange = 'isYoyChange',
  yoyChangePct = 'isYoyChangePct',
  sharePct = 'isSharePct',
}

export type RevenueSettings = {
  isShowAll: boolean
  chartView: View
} & Record<RevenueDataEnum, boolean>
